import { getPercentage, getRemainingAmount } from './helper';
import DonutChart from '../../donutchart/DonutChart';
import React from 'react';

const ChartWidget = ({ label, totalAmount, spendingAmount }) => {
  return (
    <div
      className={
        label === 'deductables' ? 'deductables-chart' : 'out-of-pocket-chart'
      }
    >
      <DonutChart
        aria-hidden={true}
        seriesRadial={[getPercentage(totalAmount, spendingAmount)]}
        chartType="radialBar"
        chartWidth="150"
      ></DonutChart>
      <p className="sr-only">
        {label === 'deductables'
          ? `Deductibles ${getPercentage(totalAmount, spendingAmount)}% Spent`
          : label === 'out-of-pocket'
          ? `Out-of-pocket ${getPercentage(totalAmount, spendingAmount)}% Spent`
          : ''}
      </p>
      <p className="deductable-rem-label m-1">
        {label === 'deductables'
          ? 'Remaining Deductibles'
          : label === 'out-of-pocket'
          ? 'Remaining Out-of-Pocket'
          : ''}
      </p>
      <p className="deductable-amount mb-4">
        {getRemainingAmount(totalAmount, spendingAmount)}
      </p>
    </div>
  );
};
export default ChartWidget;
